import React, { forwardRef, useEffect, useRef } from "react";
import videojs from "video.js";
import "videojs-playlist";
import "videojs-markers";
import "videojs-contrib-quality-levels";
import "videojs-hls-quality-selector";
import "videojs-hotkeys";

import "./VideoPlayer.scss";

export const VideoJS = forwardRef(({ options, onReady }, playerRef) => {
  const placeholderRef = useRef(null);

  useEffect(() => {
    /**
     * Make sure Video.js player is only initialized once
     */
    if (!playerRef.current) {
      const placeholderEl = placeholderRef.current;
      const videoElement = placeholderEl.appendChild(document.createElement("video-js"));

      const player = (playerRef.current = videojs(videoElement, options, () => {
        onReady && onReady(player);
        player.hotkeys({
          volumeStep: 0.1,
          seekStep: 5,
          enableModifiersForNumbers: false,
        });

        player.on("pause", () => player.bigPlayButton.show());
        player.on("play", () => player.bigPlayButton.hide());
        player.on("ended", () => {});
        player.on("timeupdate", () => {});
        player.controlBar.removeClass("vjs-hidden"); //?????
        player.hlsQualitySelector({ displayCurrentQuality: true });
      }));

      // You can update player in the `else` block here, for example:
    } else {
      const player = playerRef.current;

      player.autoplay(options.autoplay);
      player.poster(options.poster);
      player.src(options.sources);
      player.bigPlayButton.show();
    }
  }, [options, onReady]);

  /**
   * Dispose the Video.js player when the functional component unmounts
   */
  useEffect(() => {
    const player = playerRef.current;

    return () => {
      if (player) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);

  return <div ref={placeholderRef} className="video-container mb-4 rounded overflow-hidden" />;
});
